import { render, staticRenderFns } from "./BannerSettings.vue?vue&type=template&id=0f77ea6b&scoped=true&"
import script from "./BannerSettings.vue?vue&type=script&lang=js&"
export * from "./BannerSettings.vue?vue&type=script&lang=js&"
import style0 from "./BannerSettings.vue?vue&type=style&index=0&id=0f77ea6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f77ea6b",
  null
  
)

export default component.exports